/** @jsx jsx */
import { jsx } from '@emotion/core';
import React from 'react';

import { SafePureComponent } from '../../../../utils/SafePureComponent';
import Card from '../Cards';
import InfiniteCarousel from '../../../ui/InfiniteCarousel';
import * as styles from './index.styles';

class Slider extends SafePureComponent {
  renderCards() {
    const { cards } = this.props;

    return cards.map((data, index) => {
      return (
        <React.Fragment key={index}>
          <Card data={data} />
        </React.Fragment>
      );
    });
  }

  safeRender() {
    return (
      <React.Fragment>
        <InfiniteCarousel
          // breakpoints={[
          //   {
          //     breakpoint: 320,
          //     settings: {
          //       slidesToShow: 1,
          //       slidesToScroll: 1,
          //     },
          //   },
          //   {
          //     breakpoint: 480,
          //     settings: {
          //       slidesToShow: 1,
          //       slidesToScroll: 1,
          //     },
          //   },
          //   {
          //     breakpoint: 768,
          //     settings: {
          //       slidesToShow: 2,
          //       slidesToScroll: 1,
          //     },
          //   },
          //   {
          //     breakpoint: 1024,
          //     settings: {
          //       slidesToShow: 3,
          //       slidesToScroll: 1,
          //     },
          //   },
          // ]}
          autoCycle={true}
          pauseOnHover={true}
          showSides={true}
          cycleInterval={1000}
          sideSize={0.1}
          slidesToScroll={1}
          slidesToShow={4}
          scrollOnDevice={true}
          animationDuration={500}
        >
          {this.renderCards()}
        </InfiniteCarousel>
      </React.Fragment>
    );
  }
}
export default Slider;
